




import {
  defineComponent,
  watch,
  useRoute,
  computed,
  useMeta,
  useFetch,
  onActivated,
} from '@nuxtjs/composition-api'
import {
  provideProductSearch,
  injectProductSearch,
} from '~/composables/product/useProductSearch'
import { ProductEvents } from '~/composables/product/useProduct'
import { provideProductList } from '~/composables/product/useProductList'
import { useEvents } from '~/composables/framework/useEvents'
import { useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useContent } from '~/composables/useContent'
import { useBreadcrumbsSchemaScript } from '~/composables/useSchemaScript'
import { htmlToText } from '~/lib/utilities'

export default defineComponent({
  name: 'PagesSearch',

  setup() {
    provideProductList()
    provideProductSearch()

    const { emit } = useEvents()
    const route = useRoute()
    const { htmlMeta, article, ensureContent, setPageMeta } = useContent()
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    const { breadcrumbsSchemaScript, setBreadcrumbsSchemaScript } =
      useBreadcrumbsSchemaScript()
    const useProductSearchData = injectProductSearch()
    const { products, initialize } = useProductSearchData

    const term = computed(() => route.value.params.slug)

    const doSetBreadcrumbs = () => {
      setBreadcrumbs([
        {
          // label: term.value,
          label: "Zoekresultaten"
        },
      ])
    }

    useFetch(async () => {
      await Promise.all([initialize(term.value), ensureContent()])

      setPageMeta({
        title: `${term.value} zoek`,
        description:
          article.value?.description && htmlToText(article.value.description),
      })

      doSetBreadcrumbs()
      setBreadcrumbsSchemaScript(breadcrumbs.value!)
    })

    onActivated(() => {
      doSetBreadcrumbs()
    })

    watch(products, (value) => {
      if (!value || !value.length) return

      emit(ProductEvents.ViewList, {
        products: value,
      })
    })

    useMeta(() => htmlMeta.value)
    useMeta(() => {
      return breadcrumbsSchemaScript.value
        ? {
            script: [breadcrumbsSchemaScript.value],
          }
        : {}
    })

    return {
      term,
      ...useProductSearchData,
    }
  },

  head: {},
})
